import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import ModalDommus from '../../../components/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DommusWebhook } from '../../../components/DommusWebhook';
import { WebhookType } from './types';
import { WebhooksService } from '../../../services/WebhooksService';
import Swal from 'sweetalert2';
import { DommusAlertaAmarelo } from '../../../components/DommusAlertaAmarelo';
import { faCogs } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export default function Webhooks() {
    const [modalAberto, setModalAberto] = useState(false);
    const [webhooks, setWebhooks] = useState<WebhookType[]>([])

    useEffect(() => {
        WebhooksService.buscar()
            .then(response => setWebhooks(response?.data))
            .catch(error => {
                console.log(error)
                console.log(error?.response)
                Swal.fire('Ooops...', 'Houve um erro ao buscar os webhooks.', 'error')
            })
    }, [])

    return <>
        <Card.Body>
            <Card.Title>
                <FontAwesomeIcon icon={faCogs as IconProp} color="var(--secondary)" size="lg"/>
            </Card.Title>
            <Card.Text>
                Webhooks
            </Card.Text>
        </Card.Body>
        <Card.Footer as="button" className="Integrar" onClick={() => setModalAberto(true)} >
            Configurar
        </Card.Footer>
        <ModalDommus size="lg" open={modalAberto} close={() => setModalAberto(false)} titulo="Webhooks">
            <DommusWebhook setWebhooks={setWebhooks}/>
            {webhooks.length && webhooks.map(webhook => <DommusWebhook setWebhooks={setWebhooks} webhook={webhook}/>) || 
                <DommusAlertaAmarelo mensagem="Nenhum webhook configurado." classe="text-center"/>}
        </ModalDommus>
    </>
}
